import { create } from "zustand";
import { callFlowReducer, initialCallFlow, type CallFlowAction, type CallFlowState } from "./callFlowState";

// Zustand wrapper over the pure call-flow reducer (callFlow.ts). Components select
// `state` for rendering and `dispatch` to advance the flow.
interface CallFlowStore {
  state: CallFlowState;
  dispatch: (action: CallFlowAction) => void;
}

export const useCallFlow = create<CallFlowStore>((set) => ({
  state: initialCallFlow,
  dispatch: (action) => set((s) => ({ state: callFlowReducer(s.state, action) }))
}));
